import React, { useEffect } from 'react'
import InputCustom from 'components/Inputs'
import CustomSelect from 'components/Select'
import Steps from 'components/Steps'
import { useSelector } from 'react-redux'
import { Col, Row } from 'reactstrap'
import { ApplicationState } from 'store'
import { PROFISSIONAL } from 'store/modules/cadastros/profissional/types'
import { CustomButton } from 'styles/global'
import { STEPS_CADASTRO } from 'views/cadastros/constants/constants'
import { CustomTitleCadastro } from 'views/cadastros/style'
import * as profissionalActions from 'store/modules/cadastros/profissional/actions'
import useRedux from 'hooks/useRedux'
import { maskMoney, removeMaskMoney } from 'util/masks'
import { schemaCadastroClt } from '../../constants/schema'
import * as yup from 'yup'
import { toast } from 'react-toastify'

const Clt = () => {
  const {
    cadastroClt,
    optionsSelect,
    cadastroCltInvalids,
    loadingOptionsSelect
  } = useSelector<ApplicationState, PROFISSIONAL>((state) => state.profissional)

  const { dispatch } = useRedux()

  type CadastroCltFields = keyof PROFISSIONAL['cadastroClt']
  const onChange = <T extends CadastroCltFields>(
    value: T extends keyof PROFISSIONAL['cadastroClt']
      ? PROFISSIONAL['cadastroClt'][T]
      : never,
    field: T
  ) => {
    dispatch(profissionalActions.setCadastroClt(value, field))
  }

  useEffect(() => {
    dispatch(profissionalActions.getEstadosSaga())
  }, [dispatch])

  useEffect(() => {
    dispatch(profissionalActions.setCadastroClt('', 'cidadeId'))
    if (cadastroClt.siglaEstado) {
      dispatch(profissionalActions.getCidadesSaga(cadastroClt.siglaEstado))
    }
  }, [dispatch, cadastroClt.siglaEstado])

  function onSave() {
    dispatch(profissionalActions.cleanCadastroCltInvalids())
    schemaCadastroClt
      .validate(
        {
          salario: Number(removeMaskMoney(cadastroClt.salario)),
          siglaEstado: cadastroClt.siglaEstado,
          cidadeId: cadastroClt.cidadeId
        },
        { abortEarly: false }
      )
      .then(() => {
        dispatch(profissionalActions.cadastrarCltSaga())
        dispatch(profissionalActions.atualizarRdStationSaga())
      })
      .catch((err) => {
        err.inner.forEach((e: yup.ValidationError) => {
          dispatch(
            profissionalActions.setCadastroCltInvalid(
              {
                invalid: true,
                message: e.message
              },
              e.path as keyof PROFISSIONAL['cadastroCltInvalids']
            )
          )
        })
        toast.warn('Preencha todos os campos corretamente para salvar!')
      })
  }

  return (
    <div className="container-fluid d-flex flex-column row-gap-20">
      <Steps steps={STEPS_CADASTRO} currentStep={3} />
      <Row className="justify-content-center">
        <Col md={6}>
          <CustomTitleCadastro>Campos para preenchimento</CustomTitleCadastro>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md={6}>
          <label className="label-12">Salário*</label>
          <InputCustom
            type="text"
            placeholder="Digite aqui"
            onChange={(e) => {
              onChange(maskMoney(e.target.value), 'salario')
            }}
            value={cadastroClt.salario}
            invalid={cadastroCltInvalids.salario.invalid}
            errorMessage={cadastroCltInvalids.salario.message}
            infoMessage="Os valores apresentados são para efeito de simulação e podem sofrer alteração na contratação"
          />
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md={6}>
          <label className="label-12">Estado*</label>
          <CustomSelect
            placeholder="Selecione"
            options={optionsSelect.estados}
            onChange={(e) => {
              onChange(e, 'siglaEstado')
            }}
            value={cadastroClt.siglaEstado}
            invalid={cadastroCltInvalids.siglaEstado.invalid}
            errorMessage={cadastroCltInvalids.siglaEstado.message}
            isLoading={loadingOptionsSelect.estados}
            accessorLabel="nome"
            accessorValue="sigla"
          />
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md={6}>
          <label className="label-12">Cidade*</label>
          <CustomSelect
            placeholder="Selecione"
            options={optionsSelect.cidades}
            onChange={(e) => {
              onChange(e, 'cidadeId')
            }}
            value={cadastroClt.cidadeId}
            invalid={cadastroCltInvalids.cidadeId.invalid}
            errorMessage={cadastroCltInvalids.cidadeId.message}
            isLoading={loadingOptionsSelect.cidades}
            accessorLabel="nome"
            accessorValue="id"
          />
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md={6}>
          <CustomButton
            background="var(--roxo-riber)"
            width="100%"
            padding="20"
            height="50px"
            borderRadius={21}
            onClick={() => {
              onSave()
            }}
          >
            AVANÇAR
          </CustomButton>
        </Col>
      </Row>
    </div>
  )
}

export default Clt
